import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Price from '../../../../../common/Price';
import { AppState } from '../../../../../store';
import { getTomorrowsDate } from '../../../../../utils';
import { Item } from '../../AddToCart';
import { SET_ORDER_ITEMS } from '../../../../../store/types/actions/Order.actions';
import EmptyCartMessage from '../../AddToCart/EmptyCart';

const OrderSummary = (props: any) => {
    const { cartItems } = useSelector<AppState, AppState['cart']>(
        ({cart}) => cart,
    );
    const { user } = useSelector<AppState, AppState['auth']>(
		({ auth }) => auth,
	);

    const dispatch = useDispatch()

    const onContinueClick = () => {
        dispatch({
            type: SET_ORDER_ITEMS ,
            payload: cartItems
        })
        props.gotoNext()
    }

    return <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item sm={1}></Grid>
        <Grid item sm={10}>
            {(!cartItems || cartItems.length === 0) && 
                <EmptyCartMessage />
            }
            <Box display="flex" flexDirection="column" justifyContent='center'>
                {cartItems && cartItems.length > 0 && cartItems.map((item: any) => 
                    <Item style={{textAlign: 'left', padding: '18px', boxShadow: 'none', border: '1px solid #ccc', marginBottom: '1vh'}}>
                        <Box display="flex" flexDirection="row">
                            <Box display="flex" flexDirection="column">
                                <img
                                    src={`${item.image}`}
                                    alt={item.name}
                                    loading="lazy"
                                    style={{ width: '74px', height: '90px'}}
                                />
                            </Box>
                            <Box flex={1} display="flex" flexDirection="column" ml={2}>
                                <Box component="h6" display="flex" justifyContent="space-between">
                                    <span><b>Product name:</b> {item.name}</span>
                                    <span>Delivery by {getTomorrowsDate(5)} | <span style={{color: '#388e3c'}}>Free </span><del>₹40</del></span>
                                </Box>
                                <Box component="h6"><b>Seller:</b> {item.seller.seller.name}</Box>
                                <Box component="h6" display="flex"><b>Price:</b>&nbsp;<Price price={item.price} /></Box>
                            </Box>
                        </Box>
                    </Item>
                )}
                {cartItems && cartItems.length > 0  && <Item style={{border: '1px solid #ccc'}}>
                    <Box
                        display='flex'
                        sx={{ flexDirection: { xs: 'column', md: 'row' }}}
                        justifyContent="space-between"
                    >
                        <Box component="p" pl={2} mt={1}>Order confirmation email will be sent to <b>{user && user.email}</b></Box>
                        <Button
                            style={{ color: '#fff', background: 'linear-gradient(180deg, #C12902 67.71%, #E76240 100%)'}}
                            variant="outlined"
                            onClick={() => onContinueClick()}
                        >
                            Continue
                        </Button>
                    </Box>
                </Item>}
            </Box>
        </Grid>
        <Grid item sm={1}></Grid>
    </Grid>
}

export default OrderSummary;
